import {
    throttle,
    debounce,
    getHeaderHeight,
    isAdmin,
} from "kwp-core/scripts/utils/helpers";

export default () => {
    // window.addEventListener("load", () => {
    //     setScrollBarWidth();
    //     setScreenHeight();
    //     setScreenWidth();
    // });
    // window.addEventListener(
    //     "resize",
    //     throttle(() => {
    //         setScrollBarWidth();
    //         setScreenHeight();
    //         setScreenWidth();
    //     }, 250)
    // );
    // window.addEventListener(
    //     "scroll",
    //     debounce(() => {
    //         setScrollBarWidth();
    //         setScreenHeight();
    //         setScreenWidth();
    //     }, 250)
    // );
};

/**
 * Get window with accounting to the scrollbar
 */
const setScrollBarWidth = () => {
    document.documentElement.style.setProperty(
        "--scrollbarWidth",
        `${window.innerWidth - document.body.clientWidth}px`
    );
};

/**
 * Get window with accounting to the scrollbar
 */
const setScreenHeight = () => {
    const headerHeight = getHeaderHeight();
    document.documentElement.style.setProperty(
        "--screenHeight",
        `calc(100vh - ${headerHeight}px)`
    );
};

/**
 * Get window with accounting to the scrollbar
 */
const setScreenWidth = () => {
    if (isAdmin()) {
        const editorWidth = (() => {
            const adminEditor = document.querySelector(
                ".edit-post-visual-editor"
            );
            if (adminEditor) {
                return adminEditor.clientWidth + "px";
            }
            return "100vw";
        })();

        const scrollbarWidth =
            document.documentElement.style.getProperty("--scrollbarWidth");

        document.documentElement.style.setProperty(
            "--screenWidth",
            `${editorWidth - scrollbarWidth}`
        );
    }
};
